import script from "./CallNumberView.vue?vue&type=script&setup=true&lang=js"
export * from "./CallNumberView.vue?vue&type=script&setup=true&lang=js"

import "./CallNumberView.vue?vue&type=style&index=0&id=38fe082a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38fe082a"]])

export default __exports__